<script lang="ts">
  // A two-or-more-state caption whose BOX is the widest state, so flipping it
  // ("Blur on" ↔ "Blur off") reflows nothing beside it — and, on the video
  // bands, cannot reach the frame through the column's height budget.
  //
  // The alternates are stacked in the SAME grid cell as the visible text, so
  // the reservation is measured by the browser in the real font at the real
  // size rather than guessed in `ch`. They are `visibility: hidden` AND
  // `aria-hidden`, so neither the accessible name nor the tab order sees them.
  interface Props {
    /** The caption to show. */
    text: string;
    /** Every caption this control can show, including {@link text}. */
    states: readonly string[];
  }

  let { text, states }: Props = $props();
</script>

<span class="stable-label">
  <span class="sl-shown">{text}</span>
  {#each states as state (state)}
    <span class="sl-ghost" aria-hidden="true">{state}</span>
  {/each}
</span>

<style>
  .stable-label {
    display: grid;
    grid-template-areas: 'caption';
    align-items: center;
    justify-items: center;
  }

  .stable-label > * {
    grid-area: caption;
    white-space: nowrap;
  }

  .sl-ghost {
    visibility: hidden;
    pointer-events: none;
  }
</style>
